exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".my-text-style[data-v-16d2c25b] .v-text-field__slot input{color:#385d7a}", ""]);

// exports
